module.exports = __webpack_public_path__ + "assets/img/news (25).70fbec3f.png";